import {jwtDecode} from 'jwt-decode';

export const formatDate = (isoString) => {
  const date = new Date(isoString);  // Convert ISO string to Date object
  
  // Check if date is valid
  if (isNaN(date)) {
    return 'Invalid date';
  }

  const options = { year: 'numeric', month: 'short', day: '2-digit' };
  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  // Ensure month abbreviation ends with a dot
  return formattedDate.replace(/([A-Za-z]+)\s/, '$1. ');
};


export const flattenAccessItems = (accessItems) => {
  return Object.keys(accessItems)
    .filter(key => accessItems[key]) // Keep only keys with true values
    .map(key => key.charAt(0).toUpperCase() + key.slice(1)) // Capitalize first letter of each key
    .join(', '); // Convert to comma-separated string
};

// Decode JWT to get expiration time
export const getTokenExpirationTime = (token) => {
  if (!token) return null;

  try {
    const decodedToken = jwtDecode(token);
    // 'exp' is in seconds, so multiply by 1000 to convert to milliseconds
    return decodedToken.exp ? decodedToken.exp * 1000 : null;
  } catch (error) {
    console.error('Invalid token', error);
    return null;
  }
};


export const getLoggedInAdminId = () => {
  const token = localStorage.getItem('token');
  if (token) {
    const decodedToken = jwtDecode(token);
    return decodedToken.id; // Assuming the admin ID is stored as 'id' in the token
  }
  return null;
};

export const truncateString = (str, maxLength = 20) => {
  if (str?.length > maxLength) {
    return `${str.slice(0, maxLength)}...`;
  }
  return str;
};

